import { GroupLandingPageCTA } from './group-landing-page-cta'
import { GroupLandingCTAType } from './group-landing-page-cta.types'

export { GroupLandingCTAType }
export default GroupLandingPageCTA
